var _mask, _path, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGarageDoors({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1429_2041",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 11.1064L12.8436 22.7824V44.9669H43.1564V22.7824L28 11.1064ZM36.0731 28.2565H20.1255V42.3534H36.0731V28.2565Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8436 22.7824L11.6231 21.1981L10.8436 21.7985V22.7824H12.8436ZM28 11.1064L29.2206 9.52204L28 8.58176L26.7794 9.52204L28 11.1064ZM12.8436 44.9669H10.8436V46.9669H12.8436V44.9669ZM43.1564 44.9669V46.9669H45.1564V44.9669H43.1564ZM43.1564 22.7824H45.1564V21.7985L44.3769 21.1981L43.1564 22.7824ZM20.1255 28.2565V26.2565H18.1255V28.2565H20.1255ZM36.0731 28.2565H38.0731V26.2565H36.0731V28.2565ZM20.1255 42.3534H18.1255V44.3534H20.1255V42.3534ZM36.0731 42.3534V44.3534H38.0731V42.3534H36.0731ZM14.0642 24.3668L29.2206 12.6908L26.7794 9.52204L11.6231 21.1981L14.0642 24.3668ZM14.8436 44.9669V22.7824H10.8436V44.9669H14.8436ZM43.1564 42.9669H12.8436V46.9669H43.1564V42.9669ZM41.1564 22.7824V44.9669H45.1564V22.7824H41.1564ZM26.7794 12.6908L41.9358 24.3668L44.3769 21.1981L29.2206 9.52204L26.7794 12.6908ZM20.1255 30.2565H36.0731V26.2565H20.1255V30.2565ZM22.1255 42.3534V28.2565H18.1255V42.3534H22.1255ZM36.0731 40.3534H20.1255V44.3534H36.0731V40.3534ZM34.0731 28.2565V42.3534H38.0731V28.2565H34.0731Z",
    fill: "#C6AA92",
    mask: "url(#path-1-inside-1_1429_2041)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 19.8174,
    y1: 32.8743,
    x2: 36.1826,
    y2: 32.8743,
    stroke: "#BBBBBB",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 19.8174,
    y1: 39.3859,
    x2: 36.1826,
    y2: 39.3859,
    stroke: "#BBBBBB",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarageDoors);
export default __webpack_public_path__ + "static/media/GarageDoors.371bbec377c594b4d50cf3be5fc73451.svg";
export { ForwardRef as ReactComponent };